import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../axios';
import useAuth from '../../app/hooks/useAuth';

export function withRouteAccessCheck(WrappedComponent) {
  return function InnerCompo() {
    const { user, isAuthenticated } = useAuth();
    const navigate = useNavigate();
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const redirect = params.get('redirect');
    let timeout;

    const handleLogout = () => {
      localStorage.removeItem('csmyacctk');
      localStorage.removeItem('csmyaccusr');
      localStorage.removeItem('logged_csmyacctk');
      localStorage.removeItem('logged__csmyaccusr');
      ;
      delete axios.defaults.headers.common.Authorization;
      navigate('/login');
    };

    const resetTimer = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        handleLogout();
      }, 21600000); // 6 hours
    };
    const logged_csmyacctk = window.localStorage.getItem('logged_csmyacctk')

    useEffect(() => {
      if(!logged_csmyacctk || logged_csmyacctk === 'undefined'){
      
      window.addEventListener('mousemove', resetTimer);
      window.addEventListener('keydown', resetTimer);
      window.addEventListener('click', resetTimer);
      window.addEventListener('scroll', resetTimer);
      resetTimer();

      return () => {
        clearTimeout(timeout);
        window.removeEventListener('mousemove', resetTimer);
        window.removeEventListener('keydown', resetTimer);
        window.removeEventListener('click', resetTimer);
        window.removeEventListener('scroll', resetTimer);
      };
    }
    }, []);

    useEffect(() => {
      if (redirect === 'payment') {
        navigate('/paymentMethod');
      } else if (!isAuthenticated) {
        navigate('/login');
      }
    }, [user]);

    return <WrappedComponent />;
  };
}
